export default __webpack_public_path__ + "static/media/13-bm.9dae2ccd.webp";